import * as React from "react";

export const Link: React.FC<{
  readonly className?: string;
  readonly href: string;
}> = ({ children, className = "", href }) => (
  <a
    className={`${className} text-blue-700 no-underline hover:text-blue-800`}
    href={href}
  >
    {children}
  </a>
);
